<template>
<div class="content-wrap">
    <div class="event-base-wrap">
        <div class="event-wrap">
            <div class="header">
                <div class="header-container">
                    <div class="logo-container" ref="logoUrl"></div>
                    <div class="user-info">
                        <div class="user-info" v-if="isLogin">
                            <span :data-full-text="info.username" @click="toggleText">{{ info.username }}</span>
                            <span style="color: rgb(175, 175, 175);" @click="logOut">【登出】</span>
                        </div>
                        <div v-else @click="logFun">
                            <span class="text">[未登录!]</span>
                        </div>
                    </div>
                </div>
                <div class="border-bottom"></div>
            </div>
            <div class="bg-wrap">
                <div class="bg-mobile">
                </div>
                <div class="bg-pc">
                </div>åå
            </div>
            <div class="main-content-wrap">
                <div class="event-title-wrap">
                    <div class="title image-setting">
                        <div class="date">
                            <div class="date-bg-center">
                                {{ timeStr }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tree-wrap">
                    <div class="halo image-setting" :style="{ backgroundImage: 'url(' + require('@/assets/halo_yellow.png') + ')', translate: 'none', rotate: 'none', scale: 'none' }">
                    </div>
                    <div class="trunk-deco-bg image-setting" :style="{ backgroundImage: 'url(' + require('@/assets/trunk_bg_deco.png') + ')' }">
                    </div>
                    <div class="trunk image-setting" :style="{ backgroundImage: 'url(' + require('@/assets/trunk.png') + ')' }">
                    </div>
                    <div class="trunk-deco-fg image-setting" :style="{ backgroundImage: 'url(' + require('@/assets/trunk_fg_deco.png') + ')' }">
                    </div>
                    <div class="falling-obj-wrap">
                        <canvas id="fallingObjCanvas" class="falling-obj-canvas" width="576" height="559" style="touch-action: none; cursor: inherit;">
                        </canvas>
                    </div>
                    <div class="popup-text-bubble-wrap"></div>
                    <div class="tree-layer image-setting tree-layer-1" ref="treeLayer1" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_1.png') + ')' }">
                    </div>
                    <div class="tree-layer image-setting tree-layer-2" ref="treeLayer2" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_2.png') + ')' }">
                    </div>
                    <div class="tree-layer image-setting tree-layer-3" ref="treeLayer3" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_3.png') + ')' }">
                    </div>
                    <div class="tree-layer image-setting tree-layer-4" ref="treeLayer4" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_4.png') + ')' }">
                    </div>
                    <div class="tree-layer-5-deco image-setting tree-layer-5-deco-1" ref="deco1" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_5_deco_1.png') + ')' }">
                    </div>
                    <div class="tree-layer-5-deco image-setting tree-layer-5-deco-2" ref="deco2" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_5_deco_2.png') + ')' }">
                    </div>
                    <div class="tree-layer-5-deco image-setting tree-layer-5-deco-3" ref="deco3" :style="{ backgroundImage: 'url(' + require('@/assets/tree_layer_5_deco_3.png') + ')' }">
                    </div>
                    <div class="sparkle-wrap">
                        <canvas id="sparkleCanvas" class="sparkle-canvas" width="576" height="559" style="touch-action: none; cursor: inherit;">
                        </canvas>
                    </div>
                </div>
            </div>
            <div class="foreground-wrap">
                <div class="foreground">
                </div>
            </div>
            <div class="info-board-wrap">
                <div class="info-board-container">
                    <div class="info-point-container">
                        <div class="times-board-container image-setting">
                            <div class="remain-time-text remain-time-text-1">剩余次数: {{ remain }}</div>
                        </div>
                    </div>
                </div>
                <div class="btn-bet-container" @click="spinFun">
                    <div class="bet-lock image-setting " :class="{'un': remain < 1 , 'active': remain > 0}">
                    </div>
                </div>
            </div>
            <!-- 登录 -->
            <transition name="fade">
                <LoginModule v-show="showLoginModal" @customAlert="customAlert" @close="closeModal" />
            </transition>
            <transition name="fade">
                <Loading v-show="loading" class="loadingClass" />
            </transition>
            <transition name="fade">
                <DrawTimes v-if="showLogModal" @close="closeModal" />
            </transition>
            <transition name="fade">
                <FinalModule v-show="showFinalModal" @close="closeModal" :amount="amount" :isWin="isWin" />
            </transition>
            <!-- 底部 -->
            <div class="bottom-box">
                <div class="bottom-box-top">
                    <div @click="logFun">抽奖记录</div>
                    <span>|</span>
                    <div>
                        <a :href="onLink" target="_bank">联系客服</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import Loading from './LoadingModule.vue'
import DrawTimes from './DrawTimes.vue';
import LoginModule from './LoginModule.vue';
import FinalModule from './FinalModule.vue';
export default {
    data() {
        return {
            rotate: '',
            activeindex: null,
            number: 0,
            jishu: 0,
            id: '',
            price: 0,
            infoShow: false,
            infoText: '',
            commaShow: false,
            imgUrl: '',
            tagShow: 1,
            shoplist: [],

            hongbaolist: [],
            remain: 0,
            showLoginModal: false, // 是否登录
            isLogin: false,
            showFinalModal: false, // 抽奖弹框
            showLogModal: false, // 抽奖记录弹框
            onLink: '',
            info: '',
            amount: 0, // 旋转结果
            isWin: false,
            xylp_background: '',

            animationFrameId: 0,
            animationFunctions: null,
            handle: 0,
            handle1: 0,

            logoUrl: '',
            timeStr: '',

        };
    },
    computed: {
        ...mapGetters(['loading']),
        boxHeightRem() {
            return this.innerHeightRem;
        },
    },
    components: {
        Loading,
        LoginModule,
        FinalModule,
        DrawTimes
    },
    mounted() {
        this.siteInitFun()
        this.checkActivityFun()
        let _info = sessionStorage.getItem('info')
        if (_info) {
            this.getDetailFun()
        }

        this.$nextTick(async () => {
            this.animationInit()
            this.start()
        })
    },
    methods: {
        start(e = !1, t) {
            const N = {
                coin: 6,
                hongbao: 2,
                yuanbao: 1
            }
            const s = [];
            let r = null,
                o = 0,
                i = !1;
            const u = [],
                c = new Image,
                d = new Image,
                g = document.getElementById("fallingObjCanvas");

            for (let e = 1; e <= 9; e++) {
                const t = new Image;
                t.src = require(`../assets/coin_${e}.png`),
                    u.push(t)
            }
            c.src = require("../assets/rule_decoration_1.png")
            d.src = require("../assets/rule_decoration_2.png")

            let v = 0;

            const m = 2
            const p = e => {
                    const t = "coin" === e ? u.length : 1,
                        n = Math.floor(Math.random() * t),
                        a = g.width - 50 - 50;
                    return {
                        x: 50 + Math.random() * (a - 50),
                        y: g.height / 2 - 50,
                        type: e,
                        frameIndex: 0,
                        frameCount: t,
                        frameDelta: .25,
                        sequenceIndex: 0,
                        sequence: [0, 1, 2, 3, 4, 5, 6, 7, 8, 7, 6, 5, 4, 3, 2, 1],
                        startOffset: n,
                        speedY: "coin" === e ? 2 : 1,
                        scale: .5,
                        rotation: 0,
                        rotationSpeed: "hongbao" === e ? .03 + .01 * Math.random() : .05 + .1 * Math.random()
                    }
                },
                y = () => {
                    const e = [];
                    for (let t = 0; t < N.coin; t++)
                        e.push("coin");
                    for (let t = 0; t < N.hongbao; t++)
                        e.push("hongbao");
                    for (let t = 0; t < N.yuanbao; t++)
                        e.push("yuanbao");
                    return e[Math.floor(Math.random() * e.length)]
                },
                h = (e = !1) => {
                    if (!r || !g)
                        return;
                    const t = g;
                    if (r.clearRect(0, 0, t.width, t.height),
                        v++,
                        v >= m && !i) {
                        v = 0;
                        const t = new Set(s.map((e => e.type)));
                        if (e || !t.has("coin") && !t.has("hongbao") && !t.has("yuanbao")) {
                            const e = y();
                            s.push(p(e))
                        }
                    }
                    const n = s[s.length - 1];
                    if (n && n.y + 80 >= t.height && !i) {
                        const t = new Set(s.map((e => e.type)));
                        if (e || !t.has("coin") && !t.has("hongbao") && !t.has("yuanbao")) {
                            const e = y();
                            s.push(p(e))
                        }
                    }
                    s.forEach((e => {
                        if (e.y += e.speedY,
                            "coin" === e.type) {
                            e.sequenceIndex += e.frameDelta,
                                e.sequenceIndex >= e.sequence.length && (e.sequenceIndex = 0);
                            const t = Math.floor(e.sequenceIndex) % e.sequence.length;
                            e.frameIndex = (e.sequence[t] + e.startOffset) % e.frameCount
                        } else
                            e.rotation += e.rotationSpeed;
                        let t;
                        if (t = "coin" === e.type ? u[Math.floor(e.frameIndex)] : "hongbao" === e.type ? c : d,
                            !t || !t.complete || 0 === t.naturalWidth)
                            return;
                        const n = t.width * e.scale,
                            a = t.height * e.scale,
                            l = e.x + n / 2,
                            s = e.y + a / 2;
                        r.save(),
                            r.translate(l, s),
                            "coin" !== e.type && r.rotate(e.rotation),
                            r.drawImage(t, -n / 2, -a / 2, n, a),
                            r.restore()
                    }));
                    for (let a = s.length - 1; a >= 0; a--) {
                        s[a].y > g.height && s.splice(a, 1);
                    }
                    o = requestAnimationFrame((() => h(e)))
                };
            let b;
            const f = () => {
                    clearTimeout(b),
                        cancelAnimationFrame(o),
                        s.length = 0,
                        r && g && r.clearRect(0, 0, g.width, g.height)
                },
                _ = (e = !1, t = 2e3) => {
                    i = !0,
                        e ? b = window.setTimeout((() => {
                            f()
                        }), t) : f()
                };
            f(),
                i = !1;
            const n = g;
            return n ? (r = n.getContext("2d"),
                r ? (o = requestAnimationFrame((() => h(e))),
                    null != t && t > 0 ? new Promise((e => {
                        b = window.setTimeout((() => {
                            _(),
                                e()
                        }), t)
                    })) : Promise.resolve()) : Promise.resolve()) : Promise.resolve()
        },
        formatTimestampRangeWithYear(startTime, endTime) {
            const startDate = new Date(startTime * 1000);
            const endDate = new Date(endTime * 1000);

            const startYear = startDate.getFullYear();
            const endYear = endDate.getFullYear();

            let startStr = `${startDate.getMonth() + 1}月${startDate.getDate()}日`;
            let endStr = `${endDate.getMonth() + 1}月${endDate.getDate()}日`;

            // 如果跨年，在开始日期添加年份
            if (startYear !== endYear) {
                startStr = `${startYear}/${startStr}`;
                endStr = `${endYear}/${endStr}`;
            }

            return `${startStr}~${endStr}`;
        },
        async runShakeTree(t = 300) {
            const n = document.querySelector(".halo"),
                a = document.querySelector(".trunk"),
                l = document.querySelectorAll(".tree-layer-1"),
                s = document.querySelectorAll(".tree-layer-2"),
                r = document.querySelectorAll(".tree-layer-3"),
                o = document.querySelectorAll(".tree-layer-4"),
                i = document.querySelectorAll(".tree-layer-5-deco-1"),
                u = document.querySelectorAll(".tree-layer-5-deco-2"),
                c = document.querySelectorAll(".tree-layer-5-deco-3"),
                d = performance.now(),
                g = v => {
                    const m = (v - d) % t / t,
                        p = m < .5 ? 2 * m : 2 * (1 - m);
                    n && (n.style.transform = "scale(0,0)",
                        n.style.opacity = "0.5");
                    const y = (1.9 * p - 1).toFixed(2),
                        h = (.93 + .07 * p).toFixed(2);
                    a && (a.style.transform = `rotate(${y}deg) scale(1, ${h})`);
                    const b = (e, t, n, a, l) => {
                            const s = (t + (n - t) * p).toFixed(2),
                                r = (a + (l - a) * p).toFixed(3);
                            e.forEach((e => {
                                e.style.transform = `rotate(${s}deg) scale(1, ${r})`
                            }))
                        },
                        f = (e, t, n, a, l, s) => {
                            const r = (t + (n - t) * p).toFixed(2),
                                o = (a + (l - a) * p).toFixed(3);
                            e.forEach((e => {
                                e.style.transformOrigin = s,
                                    e.style.transform = `rotate(${r}deg) scale(1, ${o})`
                            }))
                        };
                    b(l, 0, .9, 1, .93),
                        b(s, .08, 3, 1, .97),
                        b(r, -2.1, -4, 1, .92),
                        b(o, 1.95, 3.4, .975, .957),
                        f(i, -4.3, -.8, .97, .99, "50% 60%"),
                        f(u, 3, .096, .95, .99, "50% 70%"),
                        f(c, 4.91, .001, .97, .97, "20% 70%"),
                        this.handle = requestAnimationFrame(g)
                };
            this.handle = requestAnimationFrame(g)
        },
        async cancelAnimationFrameFun(handle) {
            cancelAnimationFrame(handle)
        },
        animationInit() {
            const t = (e, t) => {
                const n = e % t / t * 2 * Math.PI;
                return (Math.sin(n - Math.PI / 2) + 1) / 2
            }
            // 运行树动画
            this.runTreeAnimation(this.handle, t)
        },
        runTreeAnimation(_, t) {
            this.cancelAnimationFrameFun(this.handle)
            const a = document.querySelector(".halo");
            const l = document.querySelector(".trunk");
            // 获取各层树叶元素
            const s = Array.from({
                    length: 4
                }, (e, t) =>
                document.querySelectorAll(`.tree-layer-${t + 1}`));
            const r = Array.from({
                    length: 3
                }, (e, t) =>
                document.querySelectorAll(`.tree-layer-5-deco-${t + 1}`));
            const o = 5e3; // 5秒

            // 动画帧回调
            const i = n => {
                const u = t(n, 4e3);
                const c = 1 - t(n, o);

                // 处理光环效果
                if (a) {
                    const e = .5 + .5 * u;
                    const t = 1 + .75 * u;
                    a.style.opacity = e.toFixed(2);
                    a.style.transform = `translate3d(0, 0, 0) scale(${t.toFixed(3)})`;
                }

                // 处理树干动画
                if (l) {
                    const e = -.9995 * c;
                    const t = -.9995 * c;
                    const n = 1.075 - .075 * c;
                    l.style.transform = `translate(0%, ${e}%) rotate(${t}deg) scale(${n}, 1)`;
                }

                // 处理各层树叶动画
                s.forEach((e, a) => {
                    const l = 1 - t(n - 100 * a, o);
                    const s = -1.75 * l;
                    const r = 1 + .074 * l;
                    e.forEach(e => {
                        e.style.transform = `translate(0%, ${s}%) scale(${r}, 1)`;
                    });
                });

                // 处理装饰元素动画
                r.forEach((e, a) => {
                    const l = 1 - t(n - 100 * a, o);
                    const s = -3 * l;
                    const r = -5 * l;
                    const i = -4 * l;
                    e.forEach(e => {
                        e.style.transform = `translate(${s}%, ${r}%) rotate(${i}deg)`;
                    });
                });

                // 继续下一帧动画
                this.handle = requestAnimationFrame(i);
            };
            this.handle = requestAnimationFrame(i);
        },
        async runHaloPulse() {
            this.cancelAnimationFrameFun(this.handle1)
            const t = document.querySelector(".halo");
            if (!t)
                return;
            const a = 1e3;
            let l = null;
            t.style.display = "block";
            const s = r => {
                l || (l = r);
                const o = r - l;
                if (o < a) {
                    const n = o / a,
                        l = 4 * n,
                        r = n;
                    t.style.opacity = r.toFixed(2),
                        t.style.transform = `translate3d(0, 0, 0) scale(${l.toFixed(3)})`,
                        this.handle1 = requestAnimationFrame(s)
                } else if (o < 1200) {
                    const n = (o - a) / 200,
                        l = 4 * (1 - n),
                        r = 1 - n;
                    t.style.opacity = r.toFixed(2),
                        t.style.transform = `translate3d(0, 0, 0) scale(${l.toFixed(3)})`,
                        this.handle = requestAnimationFrame(s)
                } else
                    t.style.display = "none",
                    this.cancelAnimationFrameFun(this.handle1)
            };
            this.handle1 = requestAnimationFrame(s)
        },
        customAlert(content, title, width, top) {
            if (content == undefined) {
                content = "";
            }
            if (title == undefined) {
                title = "温馨提示";
            }
            if (width == undefined) {
                width = "360px";
            }
            if (top == undefined) {
                top = "50%";
            }
            this.$modal.confirm({
                title: title,
                content: content,
                okText: '确定',
                cancelText: '取消'
            });
        },
        closeModal(visible) {
            if (visible === 'showLoginModal') {
                let _info = sessionStorage.getItem('info')
                if (_info) {
                    this.isLogin = true
                    this.info = JSON.parse(_info)
                    this.remain = this.info.total_draw_times
                }
            }
            this[visible] = false
        },
        async poolFun() {
            this.$store.dispatch('SET_LOADING', true)
            await this.$axios.post("/YQSWinningPool/getAllList", {}).then(r => {
                if (r.status === 200) {
                    const {
                        status,
                        msg
                    } = r.data
                    if (status) {
                        const {
                            list
                        } = r.data.data
                        this.hongbaolist = list
                    } else this.errorFun(msg)
                }
            }).catch(() => {});
            this.$store.dispatch('SET_LOADING', false)
        },
        async siteInitFun() {
            this.$store.dispatch('SET_LOADING', true)
            await this.$axios.post("/Site/init", {}).then(r => {
                if (r.status === 200) {
                    const {
                        status,
                        msg
                    } = r.data
                    if (status) {
                        const {
                            cs_url,
                            yqs_logo,
                            xylp_background,
                            name
                        } = r.data.data
                        this.onLink = cs_url
                        let yqs_logo_local = this.$Domain + yqs_logo
                        this.$refs.logoUrl.style.backgroundImage = `url('${yqs_logo_local}')`;

                        this.xylp_background = this.$Domain + xylp_background
                        document.title = `${name}-\u6447\u94b1\u6811`
                        this.handleIcoCreate(yqs_logo_local)
                    } else this.errorFun(msg)
                }
            }).catch(() => {});
            this.$store.dispatch('SET_LOADING', false)
        },
        handleIcoCreate(icoUrl) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = icoUrl
            document.getElementsByTagName('head')[0].appendChild(link);
        },
        async checkActivityFun() {
            this.$store.dispatch('SET_LOADING', true)
            await this.$axios.post("/YQSUser/checkActivity", {}).then(r => {
                if (r.status === 200) {
                    const {
                        status,
                        msg
                    } = r.data
                    if (status) {
                        const {
                            cs_url,
                            start_time,
                            end_time
                        } = r.data.data
                        this.onLink = cs_url
                        this.timeStr = this.formatTimestampRangeWithYear(start_time, end_time)
                    } else this.errorFun(msg)
                }
            }).catch(() => {});
            this.$store.dispatch('SET_LOADING', false)
        },
        async spinFun() {
            if (!this.isLogin) {
                this.showLoginModal = true
            } else {
                if (this.loading) return
                if (this.showFinalModal) return
                this.$store.dispatch('SET_LOADING', true)
                await this.$axios.post('/YQSUser/get', {
                    username: this.info.username
                }).then(async (r) => {
                    if (r.status === 200) {
                        const {
                            status,
                            msg
                        } = r.data
                        if (status) {
                            const {
                                total_draw_times,
                                money,
                            } = r.data.data
                            this.remain = total_draw_times
                            const t = (new Date).getTime();
                            await this.runShakeTree()
                            const e = (new Date).getTime() - t;
                            e < 1500 ? await new Promise((t => setTimeout((() => {
                                this.cancelAnimationFrameFun(this.handle),
                                    setTimeout((() => {
                                        t(!0)
                                    }), 1500)
                                if (money > 0) {
                                    this.amount = Number(money)
                                    this.isWin = true
                                    setTimeout(() => {
                                        this.showFinalModal = true
                                    }, 300);
                                } else {
                                    this.amount = 0
                                    this.isWin = false
                                    setTimeout(() => {
                                        this.showFinalModal = true
                                    }, 300);
                                }
                            }), 1500 - e))) : setTimeout((() => {
                                this.cancelAnimationFrameFun(this.handle)
                                if (money > 0) {
                                    this.amount = Number(money)
                                    this.isWin = true
                                    setTimeout(() => {
                                        this.showFinalModal = true
                                    }, 300);
                                } else {
                                    this.amount = 0
                                    this.isWin = false
                                    setTimeout(() => {
                                        this.showFinalModal = true
                                    }, 300);
                                }
                            }), 1e3)
                        } else this.errorFun(msg)
                    }
                    this.$store.dispatch('SET_LOADING', false)
                }).catch(() => {
                    this.$store.dispatch('SET_LOADING', false)
                })
            }
        },
        async getDetailFun() {
            this.$store.dispatch('SET_LOADING', true)
            let username = this.userNameFun()
            if (!username) return
            await this.$axios.post('/YQSUser/getDetail', {
                username: username
            }).then((r) => {
                if (r.status === 200) {
                    const {
                        status,
                        msg
                    } = r.data
                    if (status) {
                        this.isLogin = true
                        sessionStorage.setItem('info', JSON.stringify(r.data.data))
                        this.info = r.data.data
                        this.remain = r.data.data.total_draw_times
                    } else this.errorFun(msg)
                }
            })
            this.$store.dispatch('SET_LOADING', false)
        },
        userNameFun() {
            let _info = sessionStorage.getItem('info')
            if (_info) {
                this.isLogin = true
                let temp = JSON.parse(_info)
                return temp.username
            }
            return ''
        },
        logFun() {
            if (!this.isLogin) {
                this.showLoginModal = true
            } else this.showLogModal = true
        },
        errorFun(msg) {
            this.$message.error(msg)
        },
        logOut() {
            sessionStorage.clear();
            location.reload();
        },
        truncateText(text) {
            if (!text) return
            const maxLength = 8;
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + "...";
            }
            return text;
        },
        toggleText(element) {
            const span = element.currentTarget
            const fullText = span.getAttribute('data-full-text');
            // Check if the current text ends with "..."
            if (span.textContent.endsWith('...')) {
                // If it's truncated, show the full text
                span.textContent = fullText;
            } else {
                // If it's not truncated, show the truncated version
                span.textContent = this.truncateText(fullText);
            }
        }
    },

    watch: {}
};
</script>

<style lang="less" scoped>
.bottom-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 44px;
    line-height: 44px;
    flex-shrink: 0;
    border-top: 1px solid #FF8D8C;
    z-index: 5;

    .bottom-box-top {
        height: 44px;
        margin-top: -50px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        background-color: #660c08;

        >div {
            width: 40%;
            text-align: center;
            color: #FFF;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
        }

        span,
        a {
            color: #FFF;
        }
    }
}
</style>
